import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { NbDialogService, NbLayoutScrollService } from "@nebular/theme";
import { replace, remove, clone, find } from "lodash";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { User } from "../../@core/data/users";
import { UserService } from "../../@core/services/user.service";
import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";
import Comment from "../../models/comment.model";
import { WhereList } from "../../models/pagination";
import { CommentService } from "../../services/comment.service";

@Component({
  selector: "ngx-view-comments-new",
  styleUrls: ["./view-comments-new.component.scss"],
  templateUrl: "./view-comments-new.component.html",
})
export class ViewCommentsNewComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();

  @Input() mode?: string = "course";
  @Output() onClose: EventEmitter<any> = new EventEmitter();

  refTitle: string = "";
  refUid: string = "";
  replyForm: FormGroup;
  submitted = false;
  loading = false;

  firstData?: Comment[] = [];
  moreData?: Comment[] = [];
  comments?: Comment[] = [];
  reply?: Comment = new Comment();
  wheres: WhereList[] = [];

  isLoggedIn = false;
  uid = "anonymous";
  pageSize = 10;
  cursor: any;
  done = false;
  init = false;

  posX = 0;
  posY = 0;

  constructor(
    private fb: FormBuilder,
    private commentService: CommentService,
    public userService: UserService,
    private router: Router,
    private dialogService: NbDialogService,
    private scrollService: NbLayoutScrollService
  ) {}

  ngOnInit() {
    this.replyForm = this.fb.group({
      content: Validators.required,
    });

    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.isLoggedIn = true;
        } else {
          this.uid = "";
        }
        this.getFirst();
      });

    this.scrollService
      .getPosition()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.posX = data.x;
        this.posY = data.y;
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getFirst(): void {
    this.loading = true;

    this.wheres = [];
    if (this.mode != "home") {
      this.wheres.push({
        fieldPath: "mode",
        value: this.mode,
      });
    }

    this.wheres.push({
      fieldPath: "toUid",
      value: this.uid,
    });

    this.commentService
      .getNewComments(this.wheres, this.pageSize, null)
      .snapshotChanges(["added", "removed"])
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
            doc: c.payload.doc,
          }))
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((data) => {
        if (!this.cursor && data.length > 0) {
          this.cursor = data[data.length - 1].doc;
        }

        data.forEach((com) => {
          com.createdOn = convertTimestamp(com.createdOn);
          this.getIconMode(com);

          let item = find(this.firstData, ["id", com.id]);
          if (item) {
            item = com;
          } else if (com.refUid != this.uid) {
            if (this.init) {
              this.firstData = [com, ...this.firstData];
            } else {
              this.firstData.push(com);
            }
          }
        });

        this.comments = [...this.firstData, ...this.moreData];
        this.loading = false;
        this.init = true;

        // console.log("ViewCommentsNewComponent/first:", this.comments);
      });
  }

  loadMore() {
    this.pageSize = 12;
    //this.getComments();
  }

  navigateRef(item) {
    if (item.navigateUrl && item.navigateUrl.length > 0) {
      this.router.navigateByUrl(item.navigateUrl);
    }
  }

  onDelete(value) {
    if (value) {
      remove(this.comments, (e) => {
        return e.id == value;
      });
    }
  }

  readMoreRefTitle(item) {
    item.moreRefTitle = item.moreRefTitle == true ? false : true;
  }

  private getIconMode(data) {
    switch (data.mode) {
      case "courses":
        data.iconMode = "book-open-outline";
        data.navigateUrl = "/course/" + data.refId;
        data.preTitle = "khóa học";
        break;
      case "lecture-contents":
        data.iconMode = "file-text-outline";
        data.navigateUrl = "/lecture/" + data.refId;
        data.preTitle = "bài viết";
        break;
      case "exercises":
        data.iconMode = "award-outline";
        data.navigateUrl = "/exercise/" + data.refId;
        data.preTitle = "thử thách";
        break;
      case "qnas":
        data.iconMode = "question-mark-circle-outline";
        data.navigateUrl = "/qna/" + data.refId;
        data.preTitle = "câu hỏi";
        break;
      case "quizzes":
        data.iconMode = "layers-outline";
        data.navigateUrl = "/quiz/" + data.refId;
        data.preTitle = "câu đố";
        break;
      case "comments":
        data.iconMode = "message-square-outline";
        data.navigateUrl = "";
        data.preTitle = "bình luận";
        break;
      case "report-spams":
        data.iconMode = "alert-triangle-outline";
        data.navigateUrl = "";
        data.preTitle = "báo xấu";
        break;
      case "feedbacks":
        data.iconMode = "bulb-outline";
        data.navigateUrl = "";
        data.preTitle = "góp ý";
        break;
      case "exercise-users":
        data.iconMode = "award-outline";
        data.navigateUrl = "/exercise/" + data.refId;
        data.preTitle = "thử thách";
        break;

      default:
        data.iconMode = "globe-outline";
        data.navigateUrl = "";
        data.preTitle = "";

        break;
    }
  }
}
